import { PortableText } from '@portabletext/react'
import Toggle from '../toggle'

export default function Faq({ faqs, title }) {

  const id = title.replace(/ /g, '-')

  return (
    <div className="faq" id={id}>
      <div className="fw-bold fs-900 pb-1">{title} FAQ</div>
      {faqs?.map(faq => {
        return (
          <Toggle key={faq._id} title={faq.title}>
            <PortableText value={faq.body} />
          </Toggle>
        )
      })}
    </div>
  )
}